// extracted by mini-css-extract-plugin
export default {"wrap":"aeIhBE","icon":"beIhBE","wrapMargin":"ceIhBE","noUnderline":"deIhBE"};